import {Injectable} from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of, ReplaySubject } from 'rxjs';
import {environment} from "../../environments/environment";
import { User } from "../classes/user";

@Injectable({
  providedIn: 'root'
})

export class UserService {

  constructor(private http: HttpClient) { }
  private _user:User;

  public get user(): User {
    return this._user;
  }

  public set user(val:User) {
    this._user = val;
    this.user$.next(val)
  }

  user$ = new ReplaySubject<any>();
  roles$ = new ReplaySubject<any>(1);


  public formatUser(user_details):void {

    let usr = new User();
    usr.brand = user_details.brand;
    // Handle both camelCase (new navbar) and snake_case (old format)
    usr.first_name = user_details.profile?.names?.first_name || user_details.profile?.names?.firstName;
    usr.last_name = user_details.profile?.names?.last_system_name || user_details.profile?.names?.lastSystemName || user_details.profile?.names?.lastName;
    usr.default_locale = user_details.preferences?.default_locale || user_details.preferences?.defaultLocale;
    usr.default_unit_system = user_details.preferences?.default_unit_system || user_details.preferences?.defaultUnitSystem;
    usr.default_time_zone = user_details.preferences?.default_time_zone || user_details.preferences?.defaultTimeZone;
    usr.username = user_details.username;
    usr.user_id = user_details.user_id || user_details.userId;
    usr.resources = user_details.resources;

    this.user = usr;
  }

  public setUserRoles(roles: any):void {
    if (this._user) {
      this._user.roles = roles;
    }
    this.roles$.next(roles);
  }

  public hasUtilityDispatchRole(roles: any = this._user?.roles): boolean {
    return !!roles?.find((role: any) => role.businessRole === 'UTILITY_DISPATCH_USER');
  }

}
